<template>
  <v-footer class="pa-0 ma-0">
    <div class="bg-teal d-flex w-100 align-center px-4 py-3">
      <strong>Get connected with us on social networks!</strong>

      <v-spacer />

      <div class="d-flex align-center">
        <v-btn
          href="https://www.linkedin.com/company/yellow-duck-technologies"
          target="_blank"
          icon="mdi-linkedin"
          variant="plain"
          size="small"
        />
        <ContactForm 
          icon-only 
          button-variant="plain" 
          button-size="small"
        />
      </div>
    </div>
  </v-footer>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'AppFooter',
  components: {
    ContactForm,
  },
}
</script>

<style scoped>
.v-footer {
  border: none !important;
  border-radius: 0 !important;
}

.bg-teal {
  margin: 0 !important;
  border: none !important;
}

.d-flex.align-center {
  gap: 0;
}
</style>